import { useMutation, useQuery } from 'react-query';
import queryGetRemoteCollections from './queries/getRemoteCollections';
import queryGetTerminalRemoteCollections from './queries/getTerminalRemoteCollections';
import queryGetRemoteCollectionTransactions from './queries/getRemoteCollectionTransactions';
import mutationSendRemoteCollectionByMail from './mutations/sendRemoteCollectionByMail';
import mutationRefreshAlmaTransactions from './mutations/refreshAlmaTransactions';
import mutationSendTransactionByMail from './mutations/sendTransactionByMail';
import queryGetTotalRevenue from './queries/getTotalRevenue';

const actionsRemoteCollections = {
    // Getters
    // Get remote collections
    getRemoteCollections: (query, enabled = true) => useQuery(queryGetRemoteCollections(query, enabled)),
    // Get terminal's remote collections
    getTerminalRemoteCollections: (query, posTerminalId, enabled = true) => useQuery(queryGetTerminalRemoteCollections(query, posTerminalId, enabled)),
    // Get terminal's remote collection transactions
    getRemoteCollectionTransactions: (query, remoteCollectionId, enabled = true) => useQuery(queryGetRemoteCollectionTransactions(query, remoteCollectionId, enabled)),
    // Get total revenue
    getTotalRevenue: (query, enabled = true) => useQuery(queryGetTotalRevenue(query, enabled)),

    // Mutations
    // Send mail
    sendRemoteCollectionByMail: (onSuccess, onError) => useMutation(mutationSendRemoteCollectionByMail(onSuccess, onError)),
    // Send transaction by mail
    sendTransactionByMail: (onSuccess, onError) => useMutation(mutationSendTransactionByMail(onSuccess, onError)),
    // Refresh alma transactions
    refreshAlmaTransactions: (onSuccess, onError) => useMutation(mutationRefreshAlmaTransactions(onSuccess, onError))

};

export default actionsRemoteCollections;